'use strict';

angular.module('EmployeeEventControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'services.employeeEvent'
]);

